import { OFFICES } from "@/app/calculator/constants/calculatorData";
import { OptionButton, StepLabel } from "./Ui";
import { Home, Landmark, Building2, Layout, Inbox } from "lucide-react";


const OFFICE_ICONS = {
  virtual: <Home size={18} />,
  physical: <Building2 size={18} />,
  shopfront: <Layout size={18} />,
  business_centre: <Landmark size={18} />,
  warehouse: <Inbox size={18} />,
};


export function StepOffice({ value, onChange }) {
  return (
    <div>
      <StepLabel
        tag="Office"
        title="What type of office space do you need?"
        description="Depending on your business, will you need a flexi-desk, co-working space or an entire office? This is an important factor in calculating your total setup cost."
      />

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
        {OFFICES.map((o) => (
          <OptionButton
            key={o.id}
            id={o.id}
            label={o.label}
            sub={o.sub}
            price={o.price}
            icon={OFFICE_ICONS[o.id]}
            selected={value === o.id}
            onClick={onChange}
            className="w-full flex items-center gap-3 p-4 rounded-xl text-left
                       min-h-[64px] active:scale-[0.98] transition"
          />
        ))}
      </div>
    </div>
  );
}
